export enum StorageExpire {
  Hour = 60 * 60 * 1000,
  Day = 24 * 60 * 60 * 1000,
  Week = 7 * 24 * 60 * 60 * 1000,
  Month = 30 * 24 * 60 * 60 * 1000,
  Year = 365 * 24 * 60 * 60 * 1000,
  Forever = -1
}

interface StorageName {
  value: string
  time: number
  expire: number
}

class Storage {
  private type: 'sessionStorage' | 'localStorage'

  constructor(type: 'sessionStorage' | 'localStorage') {
    if (!window[type]) {
      throw new Error(`The current device does not support ${type}`)
    }
    this.type = type
  }

  set(key: string, value: unknown, expire: number = StorageExpire.Forever): void {
    if ((value && typeof value !== 'string') || value === false) {
      value = JSON.stringify(value)
    } else if (!value) {
      value = ''
    }
    const name = {
      value: value,
      time: Date.now(),
      expire: expire
    }
    window[this.type].setItem(key, JSON.stringify(name))
  }

  get(key: string): string {
    let name: string | null | StorageName = window[this.type].getItem(key)

    if (typeof name === 'string') {
      name = JSON.parse(name) as StorageName
    } else {
      return ''
    }
    if (Date.now() - name.time > name.expire && name.expire !== StorageExpire.Forever) {
      console.log('------ storage expired ------')
      this.remove(key)
      return ''
    } else {
      let value = name.value
      if (value === 'true' || value === 'false') {
        value = JSON.parse(value)
      }
      try {
        if (typeof value === 'string' && ['{', '['].includes(value[0])) {
          value = JSON.parse(value)
        }
      } catch (e) {
        console.log(e)
      }
      return value
    }
  }

  remove(key: string): void {
    window[this.type].removeItem(key)
  }

  clear(): void {
    window[this.type].clear()
  }
}

export const Session = new Storage('sessionStorage')
export const Local = new Storage('localStorage')
